import { OrganizationUnitShiftConfig } from '@scheduling/graphql/types';
import { Moment } from 'moment';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateOrganizationUnitShiftConfigsMutationCgResponse,
  CreateOrganizationUnitShiftConfigsMutationVariables,
  DeleteOrganizationUnitShiftConfigMutationCgResponse,
  DeleteOrganizationUnitShiftConfigMutationVariables,
  UpdateOrganizationUnitShiftConfigMutationCgResponse,
  UpdateOrganizationUnitShiftConfigMutationVariables,
} from '@common/graphql/schema';

export const CreateOrganizationUnitShiftConfigs: TypedDocumentNode<
  CreateOrganizationUnitShiftConfigsMutationCgResponse,
  CreateOrganizationUnitShiftConfigsMutationVariables
> = gql`
  mutation CreateOrganizationUnitShiftConfigs(
    $input: CreateOrganizationUnitShiftConfigsInput!
  ) {
    createOrganizationUnitShiftConfigs(input: $input) {
      organizationUnitShiftConfigs {
        id
        startTime
        endTime
        workloadStartTime
        workloadEndTime
        lunchBreakMinLength
        lunchBreakMaxLength
        lunchBreakDeductionDefault
        duration
        role {
          id
          abbreviation
        }
      }
    }
  }
`;

export const UpdateOrganizationUnitShiftConfig: TypedDocumentNode<
  UpdateOrganizationUnitShiftConfigMutationCgResponse,
  UpdateOrganizationUnitShiftConfigMutationVariables
> = gql`
  mutation UpdateOrganizationUnitShiftConfig(
    $id: ID!
    $input: UpdateOrganizationUnitShiftConfigInput!
  ) {
    updateOrganizationUnitShiftConfig(id: $id, input: $input) {
      organizationUnitShiftConfigs {
        id
        startTime
        endTime
        workloadStartTime
        workloadEndTime
        lunchBreakMinLength
        lunchBreakMaxLength
        lunchBreakDeductionDefault
        duration
        role {
          id
          abbreviation
        }
      }
    }
  }
`;

export const DeleteOrganizationUnitShiftConfig: TypedDocumentNode<
  DeleteOrganizationUnitShiftConfigMutationCgResponse,
  DeleteOrganizationUnitShiftConfigMutationVariables
> = gql`
  mutation DeleteOrganizationUnitShiftConfig($id: ID!) {
    deleteOrganizationUnitShiftConfig(id: $id) {
      organizationUnitShiftConfig {
        id
        startTime
        endTime
        duration
        role {
          id
          abbreviation
        }
      }
    }
  }
`;

export type CreateOrganizationUnitShiftConfigsVariables = {
  input: {
    organizationUnitId: string;
    roleIds?: string[];
    startTime: Moment;
    endTime: Moment;
    workloadStartTime?: Moment;
    workloadEndTime?: Moment;
    lunchBreakMinLength?: Moment;
    lunchBreakMaxLength?: Moment;
    lunchBreakDeductionDefault?: Moment;
    workforceGroupIds?: string[];
  };
};

export type CreateOrganizationUnitShiftConfigsResponse = {
  createOrganizationUnitShiftConfigs: OrganizationUnitShiftConfig[];
};

export type UpdateOrganizationUnitShiftConfigVariables = {
  id: string;
  input: {
    organizationUnitId: string;
    startTime: Moment;
    endTime: Moment;
    workloadStartTime?: Moment;
    workloadEndTime?: Moment;
    lunchBreakMinLength?: Moment;
    lunchBreakMaxLength?: Moment;
    lunchBreakDeductionDefault?: Moment;
    roleIds?: string[];
    workforceGroupIds?: string[];
  };
};

export type UpdateOrganizationUnitShiftConfigResponse = {
  updateOrganizationUnitShiftConfig: OrganizationUnitShiftConfig[];
};

export type DeleteOrganizationUnitShiftConfigVariables = {
  id: string;
};

export type DeleteOrganizationUnitShiftConfigResponse = {
  deleteOrganizationUnitShiftConfig: OrganizationUnitShiftConfig;
};
